import { FlowProps } from '../controller/FlowProps/FlowProps';
// This method is used only for migration purposes.
// It allows simply override public data for the flowAPI
// and returns an object which can be spread for setProps on user's side
export var createDangerousPublicDataOverride = function (flowAPI) { return function (publicData) {
    var _a;
    flowAPI.controllerConfig.config.publicData = publicData;
    return _a = {},
        _a[FlowProps.PropsMap.publicData] = publicData,
        _a;
}; };
//# sourceMappingURL=createDangerousPublicDataOverride.js.map